import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
//import registerServiceWorker from './registerServiceWorker'

import { Router } from 'react-router'
import createBrowserHistory from 'history/createBrowserHistory'
import store from './store'

import moment from 'moment-timezone'

import './global.css'

import App from './App'

moment.tz.setDefault('Pacific/Auckland');

const history = createBrowserHistory()

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider>
      <Router history={history}>
        <App/>
      </Router>
    </MuiThemeProvider>
  </Provider>
, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js